import Swal from 'sweetalert2'

const _Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

export default class Toast {

    static success(message) {
        _Toast.fire({
            icon: 'success',
            title: message
        })
    }

    static error(message) {
        _Toast.fire({
            icon: 'error',
            title: message
        })
    }

    static danger(message) {
        _Toast.fire({
            icon: 'error',
            title: message
        })
    }

    static warning(message) {
        _Toast.fire({
            icon: 'warning',
            title: message
        })
    }

    static info(message) {
        _Toast.fire({
            icon: 'info',
            title: message
        })
    }

    static question(message) {
        _Toast.fire({
            icon: 'question',
            title: message
        })
    }

    static timer(message, icon = 'success') {
        return new Promise((resolve, reject) => {
            _Toast.fire({
                icon: icon,
                title: message
            }).then(resolve).catch(reject)
        })
    }
}
